import type { IContextualMenuProps } from "@fluentui/react/lib/ContextualMenu";
import { getAddinSurfaceStore } from "../store/addinSurfaceStore";

/**
 * Gets the add-in surface flag for a specific extensibility mode.
 * @param extensibilityMode - The extensibility mode.
 * @returns The add-in surface flag for the specified mode, or undefined if not found.
 */
export const getAddinSurfaceFlag = (extensibilityMode: "MessageRead" | "MessageCompose" | "MultipleSelection"): boolean | undefined => {
    return getAddinSurfaceStore().surfaceFlags.get(extensibilityMode);
};

/**
 * Gets the add-in sub-menu properties for a specific cache key.
 * @param cacheKey - The cache key for the add-in command surface item.
 * @returns The add-in sub-menu properties for the specified cache key, or undefined if not found.
 */
export const getAddinSubMenuProps = (cacheKey: string): IContextualMenuProps | undefined => {
    return getAddinSurfaceStore().cache.get(cacheKey)?.subMenuProps;
};
